@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';
@import (reference) '../../../constants/spacing.module.less';

.clients-list-container {
  display: grid;
  grid-template-columns: 1fr 1fr 100px 140px 80px;
  overflow: hidden;
  font-size: 14px;
  line-height: 24px;
  background-color: @settings-page--table--body--cell--background-color;

  .loading-spinner {
    height: 100px;
    width: 100%;
    grid-column: 1 /-1;
    border-left: @settings-page--table--border;
    border-right: @settings-page--table--border;
    border-bottom: @settings-page--table--border;
  }

  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: @settings-page--table--border;
    padding: @settings-page--table--cell--padding;

    &.align-left {
      justify-content: left;
    }

    &.left {
      justify-content: flex-start;
      border-left: @settings-page--table--border;
    }

    &.right {
      border-right: @settings-page--table--border;
    }
  }

  .header-cell {
    background-color: @settings-page--table--header--cell--background-color;
    padding: @settings-page--table--cell--padding;
    border-top: @settings-page--table--border;
    border-bottom: @settings-page--table--border;
    text-align: center;
    color: @settings-page--table--header--cell--text-color;
    font-weight: @settings-page--table--header--cell--font-weight;
    font-size: @settings-page--table--font-size;

    &.text-left {
      text-align: left;
    }
  }

  .left-header-cell {
    .header-cell();
    text-align: left;
    border-left: @settings-page--table--border;
  }

  .right-header-cell {
    .header-cell();
    border-right: @settings-page--table--border;
  }
}

.add-clients-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
}

.checkbox {
  font-size: 14px;
  padding: 5px;
  margin: 12px 0;
}

.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;

  .loading-spinner-wrapper {
    display: flex;
    justify-content: center;

    .loading-spinner {
      height: 100px;
      width: 100px;
    }
  }

  & > p {
    margin: 5px 0;
    line-height: 16px;
  }

  .subtext {
    font-size: 14px;
    line-height: 1.2;
    padding-bottom: 8px;
  }
}

.menu-toggle {
  height: 32px;
  width: 32px;

  border-radius: 6px;

  color: @settings-page--selling-clients-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--selling-clients-menu--hover--background-color;
    color: @settings-page--selling-clients-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--selling-clients-menu--active--background-color;
    color: @settings-page--selling-clients-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--selling-clients-open-menu--background-color;
  color: @settings-page--selling-clients-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.cancel-pending-client-modal-body {
  .modal-body();
  line-height: 1.3;
}

.deactivate-client-modal-body {
  padding: @space-16 @space-12;
  line-height: 1.3;
}
